export const LEAD_SOURCES = {
    WWYM: '5be93e5f683059f77dbcef48',
    MP: '5d6cd33b6f5dd301d539d68c',
    LoM: '5be93e5f683059f77dbcef4c',
    WWAB: '5be93e5f683059f77dbcef4a',
    BEN: '604a3806d53ce85138abe8c1',
    SBS: '6107a6755cb21ec7d7ffc578',
    TBB: '5fce175a1bde127479029e8b',
    GC: '609d587e1df1a9ee8a023b60',
    SBF: '5be93e5f683059f77dbcef4b',
    WBABCOUK: '620569e44f727bea514edd08',
    'SBF - Part Ex': '5caf0ab9c2520a5844ef6a89',
    WBBUK: '6011a36469160e5c207cbf64',
    MBT: '5be93e5f683059f77dbcef49',
    WBABCOM: '61f3b7e42b1c492b481f354d'
};


// WEBPACK FOOTER //
// ./src/common/constants/leadSources.js